import React from 'react'
import './Footer.css'
import FooterCopyRight from './FooterCopyRight'
import FooterLinking from './FooterLinking'

function Footer() {
    return (
        <div className="Footer">
            <div className="">
                <div className="footerTop">
                    <FooterLinking />
                </div>
                <div className="footerBottom">
                    <hr/>
                    <FooterCopyRight />
                </div>
            </div>
        </div>
    )
}

export default Footer
